module.exports = __webpack_public_path__ + "img/sticker-0-7.9a7bedb5.svg";